import React from "react";

import translations from "../translations/paiement-success";
import headerTranslations from "../components/header/header-translations";
import { CheckIcon, PhoneIcon } from "../components/articlesList/BlogIcons";
import { cloudinary } from "../components/articlesList/articleUtils";

const SUCCESS_IMAGE = "https://res.cloudinary.com/dgdbo8vri/dpr_auto,q_auto/v1791370742/transfert-lyon-val-d-isere-van-noir.webp";

const PaiementSuccess = (props) => {
  const t = translations[props.lang];

  return (
    <div className="quote">
      <div className="pay-page success-page">
        <div className="success-card">
          <div className="success-body">
            <span className="success-icon" aria-hidden="true"><CheckIcon /></span>
            <span className="eyebrow">{t.eyebrow}</span>
            <h1>{t.title}</h1>
            <p className="lead">{t.subtitle}</p>
            <div className="success-next">
              <strong>{t.nextTitle}</strong>
              <p>{t.next}</p>
            </div>
            <div className="success-next">
              <strong>{t.contactTitle}</strong>
              <p>{t.contact}</p>
              <div className="pay-help">
                <a href="tel:+33660265336"><PhoneIcon />{headerTranslations[props.lang].phone}</a>
                <a href="mailto:contact@davoyage.com">contact@davoyage.com</a>
              </div>
            </div>
            <p className="success-soon">{t.soon}</p>
            <a className="success-home" href={t.home.link}>{t.home.label}</a>
          </div>
          <img
            className="success-img"
            src={cloudinary(SUCCESS_IMAGE, "c_fill,g_south,ar_4:5,w_900")}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default PaiementSuccess;
